module.exports = __webpack_public_path__ + "img/AvatarGoetz.6761286a.jpg";